module.exports = __webpack_public_path__ + "img/ios-redo.b012efa3.svg";